$(document).ready(function () {
  if ($(".social-share__link").length > 0) {
    // On clicks of media icons
    $(".social-share__link").click(function () {
      var sharelink = $(this).attr("data-sharelink");
      var url = $(this).attr("data-url");
      window.open(
        sharelink + url,
        "_blank",
        "height=400,width=600,menubar=0,resizable=1,toolbar=0,location=0",
        true
      );
    });
  }
});
